module.exports = __webpack_public_path__ + "assets/img/text-to-speech-case3.14c81319.png";